import React from "react";
import { MdClose } from "react-icons/md";

interface ImageErrorToastProps {
  message: string | null;
  onDismiss: () => void;
}

/** Fixed bottom-right error banner used under the image upload blocks. */
const ImageErrorToast: React.FC<ImageErrorToastProps> = ({
  message,
  onDismiss,
}) => {
  if (!message) return null;

  return (
    <div className="fixed bottom-4 right-4 max-w-md rounded-md border border-red-200 bg-red-50 p-4 shadow-lg dark:border-red-700 dark:bg-red-900">
      <div className="flex items-start">
        <div className="flex-1">
          <div className="text-sm text-red-800 dark:text-red-200">
            {message}
          </div>
        </div>
        <button
          onClick={onDismiss}
          className="ml-3 text-red-500 hover:text-red-700"
        >
          <MdClose className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default ImageErrorToast;
